import * as ACTIONS_NAME from '../actions/carousel';

const initialState = {
  imageBGHandler: { active: false },
};

export default function playAndGo(state = initialState, action) {
  switch(action.type) {
   case ACTIONS_NAME.SET_BACKGROUND:
    const imageBGData = action.data;
    return Object.assign({}, state, { imageBGHandler: imageBGData });

  default:
    return state;
  }
}
